export const VIEWER_PICK_MODE = {
  NONE: "none",
  AUTO: "auto",
  ASSEMBLY: "assembly",
  PARTS: "parts"
};
